module.exports = __webpack_public_path__ + "static/media/404.63fe4d5f.svg";